import React from 'react'

import { numberBrFormatter } from 'utils/utils'

import * as S from './styles'

const ChartTooltip = ({ data: { color, data } }) => (
  <S.Container className="shadow chart-tooltip">
    <div className="chart-tooltip-title">
      <span className="font-weight-bold">{data.date}</span>
    </div>

    <div className="chart-tooltip-content">
      <div className="chart-tooltip">
        <div>
          <div
            className="chart-tooltip-color"
            style={{ backgroundColor: color.faturamento }}
          />
          <span>Faturamento:</span>
        </div>

        <span>
          R$
          {numberBrFormatter(data.faturamento, 2)}
        </span>
      </div>
      <div className="chart-tooltip">
        <div>
          <div
            className="chart-tooltip-color"
            style={{ backgroundColor: color.custoProdutos }}
          />
          <span>Custo dos Produtos:</span>
        </div>
        <span>
          R$
          {numberBrFormatter(data.custoProdutos, 2)}
        </span>
      </div>
      <div className="chart-tooltip">
        <div>
          <div
            className="chart-tooltip-color"
            style={{ backgroundColor: color.ticketMedio }}
          />
          <span>Ticket médio:</span>
        </div>
        <span>
          R$
          {numberBrFormatter(data.ticketMedio, 2)}
        </span>
      </div>
    </div>
    <div className="chart-tooltip-profit">
      <div className="chart-tooltip">
        <div>
          <div
            className="chart-tooltip-color"
            style={{ backgroundColor: color.lucroLiquido }}
          />
          <span className={`text-${data.lucroLiquido > 0 ? 'green' : 'red'}`}>
            Lucro Líquido:
          </span>
        </div>

        <span className={`text-${data.lucroLiquido > 0 ? 'green' : 'red'}`}>
          R$ {numberBrFormatter(data.lucroLiquido, 2)}
        </span>
      </div>
    </div>
  </S.Container>
)

export default ChartTooltip
